import { observable, action, computed } from 'mobx'
import Parse from 'parse'
import _ from 'lodash'
import moment from 'moment'
import UserStore from './UserStore'

class ResidenceBookingStore {

    @observable bookingsPerDate
    @observable activeBookings
    @observable allResidenceBookings

    // Data for future Booking
    @observable bookingDate
    @observable arrivalDate
    @observable arrivalTime
    @observable bookingSuccess
    @observable errorMessage
    @observable depatureDate

    // Data which is shared between screens of bookingModal
    @observable screenNumber

    constructor() {
        this.activeBookings = null
        this.allResidenceBookings = null

        this.bookingsPerDate = null

        this.bookingDate = null
        this.arrivalDate = null
        this.arrivalTime = null
        this.bookingSuccess = null
        this.errorMessage = null
        this.depatureDate = null

        this.screenNumber = 1
    }

    @computed get isActiveBookings() {
        return this.activeBookings && this.activeBookings[0].objectId ? true : false
    }
    @computed get isAllActiveBookings() {
        return this.allResidenceBookings ? true : false
    }

    @action setActiveBookings = (activeBookings) => {
        this.activeBookings = activeBookings
    }

    @action setAllActiveBookings = (activeBookings) => {
        this.allResidenceBookings = activeBookings
    }

    @action sortActiveBookings = () => {
        if (this.activeBookings) {
            this.activeBookings = _.orderBy(this.activeBookings, ['bookingStart.iso'], ['asc'])
        }
        if (this.allResidenceBookings) {
            this.allResidenceBookings = _.orderBy(this.allResidenceBookings, ['bookingStart.iso'], ['asc'])
        }
    }

    @action setScreenNumber = (screenNumber) => {
        this.screenNumber = screenNumber
    }
    @action setBookingsPerDate = (bookingsPerDate) => {
        this.bookingsPerDate = bookingsPerDate
    }
    @computed get isBookingsPerDate() {
        return this.bookingsPerDate ? true : false
    }

    @computed get isDate() {
        return this.bookingDate ? true : false
    }

    @computed get isBookingSet() {
        return this.bookingDate && this.arrivalDate && this.depatureDate && this.arrivalTime ? true : false
    }

    @action setDate = (bookingDate) => {
        this.bookingDate = bookingDate
    }
    @action setArrivalDate = (arrivalDate) => {
        this.arrivalDate = arrivalDate
    }
    @action setArrivalTime = (arrivalTime) => {
        this.arrivalTime = arrivalTime
    }
    @action setDepatureDate = (depatureDate) => {
        this.depatureDate = depatureDate
    }

    cancelBooking(bookingId) {

        let bookingObject = null
        let bookingQuery = new Parse.Query("ResidenceBooking")

        bookingQuery.equalTo("objectId", bookingId)
        return bookingQuery.each(result => {
            bookingObject = result
        }).then(() => {
            bookingObject.set("isCanceled", true);
            return bookingObject.save().then(res => {
                this.cancledBooking = bookingObject.toJSON()
            })
        });
    }

    getActiveBookings = () => {

        this.activeBookings = null
        let activeBookings = []
        let allBookings = []

        // const today = new Date().toISOString().substr(0, 10)

        let bookingQuery = new Parse.Query("ResidenceBooking")
        bookingQuery.include("user")
        bookingQuery.equalTo("isCanceled", false)
        //bookingQuery.greaterThan("bookingDate", today)

        bookingQuery.each((booking, key) => {
            allBookings.push(booking.toJSON())
            // let today = moment()
            if (UserStore.isLoggedIn && (booking.toJSON().user.company.objectId === UserStore.me.company.objectId) /*&& (today.isSameOrBefore(booking.toJSON().bookingEnd.iso))*/) {
                activeBookings.push(booking.toJSON())
            }
        }).then(res => {
            this.setAllActiveBookings(allBookings)
            if (activeBookings.length === 0) {
                //this.setUserFreeBookings(UserStore.maxBookings)
            } else {
                this.setActiveBookings(activeBookings)
                this.sortActiveBookings()
            }
        }).catch(err => {
            console.error("error active bookings", err)
        })

    }


    getBookings() {
        Parse.Cloud.run('isResidenceBookingAllowed', { "currentUserId": UserStore.me.objectId })
            .then(result => {
            })
            .catch(error => {
                console.error("error", error)
            })

        let residenceBookings = {}
        let residenceQuery = new Parse.Query("ResidenceBooking")
        residenceQuery.equalTo("isCanceled", false)

        residenceQuery.find().then(bookings => {
            bookings.forEach(booking => {
                residenceBookings[booking.toJSON().bookingStart.iso] = booking.toJSON()
            })
            this.setBookingsPerDate(residenceBookings)
        }).catch()
    }

    createBooking() {
        const BookingParseObj = Parse.Object.extend("ResidenceBooking")
        let newBooking = new BookingParseObj()

        const CompanyObj = Parse.Object.extend("Company")
        let company = new CompanyObj()
        company.id = UserStore.company.objectId
        newBooking.set("arrival", this.arrivalDate)
        newBooking.set("arrivalTime", this.arrivalTime)
        newBooking.set("depature", this.depatureDate)
        newBooking.set("user", Parse.User.current())



        let bookinStart = moment(this.arrivalDate)
        let bookingEnd = moment(this.depatureDate)
        let today = moment()
        if (today.isSameOrBefore(bookingEnd) && UserStore.userResidenceRole.hasRemainingStock) {
            if (bookingEnd.isBefore(today.day(8)) && bookinStart.isBefore(today.day(8))) {
                newBooking.set("isRemainingStock", true)

            } else {
                newBooking.set("isRemainingStock", false)
            }
        }



        newBooking.set("isCanceled", false)
        newBooking.set("company", company)
        newBooking.set("bookingStart", this.arrivalDate)
        newBooking.set("bookingEnd", this.depatureDate)

        newBooking.save().then(result => {
            this.resetData(0)
            this.rerender()
        }).catch(error => {
            console.error("result err", error)
            this.bookingSuccess = false
            this.screenNumber = 4
            switch (error.message.errorCode) {
                case 1: this.errorMessage = "Sie haben bereits alle von Ihren " + error.message.vars.maxBookingCount + " möglichen Buchungen eingelöst!"; break;
                case 2: this.errorMessage = "Es ist erst ab " + error.message.vars.validBookingDate + " wieder mögich eine neue Buchung zu tätigen"; break;
                default: this.errorMessage = error.message.message; break;
            }
        })
    }

    resetData(option) {
        this.arrivalDate = null
        this.arrivalTime = null
        this.depatureDate = null
        if (option === 1) {
            this.bookingDate = null
            this.bookingSuccess = null
        }
        this.errorMessage = null
    }

    rerender() {
        this.getBookings()
        this.getActiveBookings()
    }

}

const store = new ResidenceBookingStore()
export default store



// WEBPACK FOOTER //
// /src/stores/ResidenceBookingStore.js